const tripTypeUtils = require('../../../modules/utils/trip_type');
const FilterContainerModel = require('../filter_container.model');

const containerNames = [
    'time',
    'stops',
    'baggage',
    'airports',
    'airlines',
    'paymentMethod',
];

module.exports = {

    defaults: function() {
        return Odigeo._.reduce(containerNames, function(models, containerName) {
            models[containerName] = new FilterContainerModel();
            return models;
        }, {});
    },
    setLabel: function(model) {
        const isRoundTrip = tripTypeUtils.isRoundTrip(this.widget.tripType);
        this.get(model.container).get('filterSummary').get(isRoundTrip ? 0 : model.index).setTag(model);
    },
    toggleFilterSummaries: function(currentTabIndex, nextTabIndex) {
        Odigeo._.each(containerNames, Odigeo._.bind(function(containerName) {
            const filterSummaryCollection = this.get(containerName).get('filterSummary');
            filterSummaryCollection.get(currentTabIndex).set('active', false);
            filterSummaryCollection.get(nextTabIndex).set('active', true);
        }, this));
    },
};
